import { WizardStep } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { NetsuiteWizardData } from 'modules/integrations_netsuite/lib/types'

import { accountIdStep } from './accountIdStep'
import { clientIdStep } from './clientIdStep'
import { generateCertificateStep } from './generateCertificateStep'
import { purchaseOrdersStep } from './purchaseOrdersStep'
import { verifyStep } from './verifyStep'

export const useNetsuiteSteps = (
  integration: ItemIntegrationFragment
): (() => WizardStep<NetsuiteWizardData>)[] => {
  return [
    accountIdStep,
    clientIdStep,
    generateCertificateStep(integration),
    verifyStep(integration),
    purchaseOrdersStep,
  ]
}
